import React, { useCallback, useEffect, useRef, useState } from 'react';

export function useAudioPlayer(): {
  playingTaxa: string | null;
  handlePlay: (taxa: string, soundClipUrl: string | null) => void;
} {
  const [playingTaxa, setPlayingTaxa] = useState<string | null>(null);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    return () => { audioRef.current?.pause(); };
  }, []);

  const handlePlay = useCallback((taxa: string, soundClipUrl: string | null) => {
    if (!soundClipUrl) return;
    if (playingTaxa === taxa) {
      audioRef.current?.pause();
      setPlayingTaxa(null);
      return;
    }
    audioRef.current?.pause();
    const audio = new Audio(soundClipUrl);
    audio.onended = () => setPlayingTaxa(null);
    audioRef.current = audio;
    void audio.play();
    setPlayingTaxa(taxa);
  }, [playingTaxa]);

  return { playingTaxa, handlePlay };
}

export function PlayPauseIcon({ isPlaying, size = 8, playFill = 'white', pauseFill = 'white' }: {
  isPlaying: boolean;
  size?: number;
  playFill?: string;
  pauseFill?: string;
}): React.JSX.Element {
  return isPlaying ? (
    <svg width={size} height={size} viewBox="0 0 8 8" fill="none">
      <rect x="0.5" y="0" width="2.5" height="8" fill={pauseFill} rx="0.5" />
      <rect x="5" y="0" width="2.5" height="8" fill={pauseFill} rx="0.5" />
    </svg>
  ) : (
    <svg width={size} height={size} viewBox="0 0 8 8" fill="none">
      <path d="M1.5 0.5L7 4L1.5 7.5V0.5Z" fill={playFill} />
    </svg>
  );
}
